import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Collapse,
  Chip,
  Badge,
  Tooltip,
  Avatar,
} from '@mui/material';
import {
  Dashboard,
  Business,
  Message,
  Settings,
  People,
  Analytics,
  Notifications,
  ExpandLess,
  ExpandMore,
  AdminPanelSettings,
  Security,
  Cloud,
  Storage,
  Code,
  BugReport,
  Assessment,
  Timeline,
  TrendingUp,
  AccountTree,
  Build,
  Subscriptions,
  CardMembership,
  Payment,
} from '@mui/icons-material';
import authService from '../../services/auth';
import './SuperAdminNavigation.css';

const SuperAdminNavigation = ({ onMenuClick, isMobile }) => {
  const location = useLocation();
  const [systemMenuOpen, setSystemMenuOpen] = useState(true);
  const [monitoringMenuOpen, setMonitoringMenuOpen] = useState(false);
  const user = authService.getUser();

  // Check if current path is active
  const isActivePath = (path) => {
    return location.pathname === path;
  };

  // Main Super Admin menu items
  const mainMenuItems = [
    { 
      text: 'Dashboard', 
      icon: <AdminPanelSettings />, 
      path: '/superadmin/dashboard', 
      description: 'System overview and analytics'
    },
    { 
      text: 'Registrations', 
      icon: <Business />, 
      path: '/superadmin/tenants', 
      description: 'Manage all system tenants'
    },
    { 
      text: 'Email Templates', 
      icon: <Message />, 
      path: '/superadmin/email-templates', 
      description: 'Manage email templates and variables'
    },
  ];

  // Subscription Management menu items
  const subscriptionMenuItems = [
    { 
      text: 'Subscription Plans', 
      icon: <CardMembership />, 
      path: '/superadmin/subscription-plans', 
      description: 'Manage subscription plans and pricing'
    },
    { 
      text: 'Features', 
      icon: <Build />, 
      path: '/superadmin/subscription-features', 
      description: 'Manage subscription features and categories'
    },
    { 
      text: 'Tenant Subscriptions', 
      icon: <Subscriptions />, 
      path: '/superadmin/tenant-subscriptions', 
      description: 'View and manage tenant subscriptions'
    },
    { 
      text: 'Subscription Analytics', 
      icon: <Analytics />, 
      path: '/superadmin/subscription-analytics', 
      description: 'Subscription statistics and insights'
    },
  ];
 

  // Render menu item
  const renderMenuItem = (item, section = 'main') => {
    const active = isActivePath(item.path);
    
    return (
      <Tooltip 
        key={item.path} 
        title={item.description || item.text} 
        placement="right" 
        arrow
      >
        <ListItem disablePadding className="superadmin-navigation-item">
          <ListItemButton
            onClick={() => onMenuClick(item.path)}
            className={`superadmin-navigation-item-button ${active ? 'active' : ''}`}
          >
            <ListItemIcon
              className={`superadmin-navigation-item-icon ${active ? 'active' : ''}`}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText 
              primary={item.text}
              className={`superadmin-navigation-item-text ${active ? 'active' : ''}`}
            />
          </ListItemButton>
        </ListItem>
      </Tooltip>
    );
  };

  return (
    <Box className="superadmin-navigation-container">
     
      {/* Main Navigation */}
      <Box className="superadmin-navigation-section"> 
        <Typography 
          variant="overline" 
          className="superadmin-navigation-section-title"
        >
          Super Admin
        </Typography>
        <List className="superadmin-navigation-list">
          {mainMenuItems.map(item => renderMenuItem(item, 'main'))}
        </List>
      </Box>

      {/* Subscription Management Section */}
      <Divider className="superadmin-navigation-divider" />
      <Box className="superadmin-tenant-section">
        <Typography 
          variant="overline" 
          className="superadmin-navigation-section-title"
        >
          SUBSCRIPTION MANAGEMENT
        </Typography>
        <List className="superadmin-navigation-list">
          {subscriptionMenuItems.map(item => renderMenuItem(item, 'subscription'))}
        </List>
      </Box>
  
    </Box>
  );
};

export default SuperAdminNavigation; 